/* RESPONSIBLE TEAM: team-frontend-tech */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { get } from 'embercom/lib/ajax';

export default class BenchmarkRoute extends Route {
  @service declare appService: AppService;

  async model(): Promise<Array<any>> {
    return get(`/ember/admins`, {
      app_id: this.appService.app.id,
    });
  }
}
